export default [
    {
        path: '/:organisation/accounting/book-keeping-settings/update-book-close-date',
        name: 'accounting.book-keeping-settings.update-book-close-date',
        component: () => import('@/pages/[organisation]/accounting/book-keeping-settings/update-book-close-date.vue'),
        meta: {
            guestRequired: false,
            loginRequired: true,
            permission: 'access.system.tenant.update-book-keeping-setting',
        },
    },
];
